import { Device, DeviceInfo } from '@capacitor/device';
import { SimpleModalService } from '@looorent/ngx-simple-modal';

import { ConfirmationModalComponent } from '@app/web/modals/confirmation-modal/confirmation-modal.component';
import { GetPlatformInteractor } from '@together/common';
import { Capacitor } from '@capacitor/core';

export class NativeStoreRedirectService {
    private excludeUrlsFromRedirect = ['promopayment', 'promopayment-success'];

    constructor(
        protected modalService: SimpleModalService,
        protected storeAndroidURL: string,
        protected storeIOSURL: string,
        protected getPlatform: GetPlatformInteractor
    ) {}

    async check(): Promise<void> {
        const url = new URL(window.location.href);
        const shouldExclude = this.excludeUrlsFromRedirect.some(route => {
            return url.pathname.includes(route);
        });
        const deviceInfo = await Device.getInfo();
        // Is not running in capacitor
        if (!this.getPlatform.isNative() && !shouldExclude) {
            if (deviceInfo.operatingSystem === 'android') {
                const openStore = await this.modalService
                    .addModal(ConfirmationModalComponent, {
                        title: 'Open Google Play?',
                        message: 'Together App is available for Android, do you want to open the Google Play store?',
                    })
                    .toPromise();

                if (openStore) {
                    window.location.replace(this.storeAndroidURL);
                }
            }

            if (deviceInfo.operatingSystem === 'ios') {
                window.location.replace(this.storeIOSURL);
            }
        }
    }
}
